module.exports = "/_next/static/images/18-1-14215c403197f077afae306f58f29251.svg";